<template>
  <div class="staff-portal">
    <header class="sp-heading">
      <div>
        <p class="sp-eyebrow">YOUR WORKPLACE, IN ONE PLACE</p>
        <oxd-text tag="h1" class="sp-title">Staff Portal</oxd-text>
        <p class="sp-muted">
          Find policies, prepare for your review, and connect with HR.
        </p>
      </div>
    </header>
    <nav class="sp-tabs" aria-label="Staff portal">
      <a
        v-for="tab in tabs"
        :key="tab.id"
        :href="localUrl(`/staff/${tab.id}`)"
        :aria-current="activeTab === tab.id ? 'page' : undefined"
        :class="{'sp-tab-active': activeTab === tab.id}"
        >{{ tab.title }}</a
      >
    </nav>
    <resources-page v-if="activeTab === 'handbook'" />
    <benefits-page v-else-if="activeTab === 'benefits'" />
    <reviews-page v-else-if="activeTab === 'reviews'" />
    <requests-page v-else />
  </div>
</template>

<script>
import ResourcesPage from './ResourcesPage.vue';
import BenefitsPage from './BenefitsPage.vue';
import ReviewsPage from './ReviewsPage.vue';
import RequestsPage from './RequestsPage.vue';
import {localUrl} from '../portal';

export default {
  components: {ResourcesPage, BenefitsPage, ReviewsPage, RequestsPage},
  props: {defaultTab: {type: String, default: 'handbook'}},
  setup(props) {
    const tabs = [
      {id: 'handbook', title: 'Handbook & Forms'},
      {id: 'benefits', title: 'Benefits & Holidays'},
      {id: 'reviews', title: 'My Reviews'},
      {id: 'requests', title: 'HR Requests'},
    ];
    return {
      tabs,
      localUrl,
      activeTab: tabs.some((tab) => tab.id === props.defaultTab)
        ? props.defaultTab
        : 'handbook',
    };
  },
};
</script>

<style lang="scss" src="../staff-portal.scss"></style>
